import { useState, useRef } from 'react';
import { InternalOverlay } from 'react-rainbow-components';
import { useOutsideClick } from '@rainbow-modules/hooks';
import TagBadge from 'components/Tags/badge';
import Badge from '../../Badge';
import {
    Container, BadgeContainer, Dropdown, DropdownHeader, BadgesGrid,
} from './styled';

interface ColumnTagsProps {
    value?: string[];
    maxBadges?: number;
    borderRadius?: 'square' | 'semi-rounded' | 'rounded' | 'semi-square';
    agentId: string;
    entity: 'customer' | 'call' | 'opportunity' | 'workspace';
}

const ColumnTags = ({
    value = [],
    maxBadges = 3,
    borderRadius = 'semi-rounded',
    agentId,
    entity,
}: ColumnTagsProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);
    const triggerRef = useRef<HTMLDivElement>(null);
    const visibleTags = value.slice(0, maxBadges);
    const remainingCount = value.length - maxBadges;
    const showMoreBadge = remainingCount > 0;

    useOutsideClick(
        dropdownRef,
        (event) => {
            if (event.target !== triggerRef.current) {
                setIsOpen(false);
            }
        },
        isOpen,
    );

    if (!value || value.length === 0) return null;

    return (
        <Container>
            {visibleTags.map((tag) => (
                <TagBadge key={tag} tag={tag} agentId={agentId} entity={entity} />
            ))}

            {showMoreBadge && (
                <BadgeContainer
                    key="tag-more"
                    onClick={() => setIsOpen(!isOpen)}
                    ref={triggerRef}
                    clickable
                >
                    <Badge variant="outline-brand" borderRadius={borderRadius}>
                        +
                        {remainingCount}
                        {' '}
                        more
                    </Badge>
                </BadgeContainer>
            )}
            <InternalOverlay
                isVisible={isOpen}
                render={() => (
                    <Dropdown id="tag-more" ref={dropdownRef}>
                        <DropdownHeader>
                            Tags (
                            {value.length}
                            )
                        </DropdownHeader>
                        <BadgesGrid>
                            {value.map((tag) => (
                                <TagBadge
                                    key={tag}
                                    tag={tag}
                                    agentId={agentId}
                                    entity={entity}
                                />
                            ))}
                        </BadgesGrid>
                    </Dropdown>
                )}
                triggerElementRef={() => ({ current: triggerRef.current })}
            />
        </Container>
    );
};

export default ColumnTags;
